import type { GetPrebidUserIds, PrebidIdPartnerConfig } from "./IdPartners";

interface YahooConnectIdConfig {
  name: string;
  params: {
    pixelId: string;
    he?: string; // The SHA-256 hashed user email address which has been lowercased prior to hashing
    puid?: string; // A domain-specific user identifier such as a first-party cookie
  };
  storage?: {
    type: "cookie" | "html5";
    name: string;
    expires?: number;
  };
}

/**
 * @see https://docs.prebid.org/dev-docs/modules/userid-submodules/yahoo.html
 */
export const yahooConnectIdPartner: GetPrebidUserIds = (
  config: PrebidIdPartnerConfig,
) => {
  if (!config.icPrebidYahooConnectId) {
    return undefined;
  }

  return {
    name: "connectId",
    params: {
      pixelId: "58833",
      // TODO: Replace when https://github.com/Wikia/odyssey/pull/202 is merged
      puid: window.fandomContext?.tracking?.ppid ?? "0",
    },
    storage: {
      type: "html5",
      name: "connectId",
      expires: 15, // 15 is value recommended by Yahoo
    },
  } satisfies YahooConnectIdConfig;
};
